import { isEmpty } from "lodash";
import { CalendarView, Row } from "PFApp/booking/types";
import { useProfilesBookings, UseProfilesBookingsReturn } from "PFCore/hooks/queries/profile";
import { useMemo } from "react";

import { useCalendarGridScope } from "../../../hooks";
import { WorkforceCalendarData } from "../booking_overview_context.types";
import { useBookingsOverviewContext } from "../bookings_overview_context";
import { AllBookingsModeRowsStateType } from "./booking_rows_context";
import { isRowContainingBookings, mapToProfileWithActivityId } from "./use_row_bookings.utils";

interface UseRowBookings {
  allBookingsModeRowsState: AllBookingsModeRowsStateType;
  rowsByKey: Record<string, Row>;
  rows: Row[];
}

export const useRowBookings = ({
  allBookingsModeRowsState,
  rowsByKey,
  rows
}: UseRowBookings): UseProfilesBookingsReturn => {
  const { calendarMode } = useBookingsOverviewContext();
  const {
    calendarData: { view, metric }
  } = useBookingsOverviewContext<WorkforceCalendarData>();

  const profilesWithActivityId = useMemo(
    () =>
      rows
        .filter((row) => isRowContainingBookings(row, calendarMode, view))
        .map((row) => mapToProfileWithActivityId(row, rowsByKey, calendarMode, allBookingsModeRowsState)),
    [rows, calendarMode, allBookingsModeRowsState, view, metric, rowsByKey]
  );
  const dateRange = useCalendarGridScope();

  return useProfilesBookings({
    profiles: profilesWithActivityId,
    dateRange,
    enabled: !isEmpty(profilesWithActivityId),
    withDurationBreakdown: view === CalendarView.WallPlanner
  });
};
